import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpService } from 'src/app/services/http.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoginDetail } from 'src/app/models/auth.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginError: string = null;

  constructor(
    private router: Router,
    private snapshot: ActivatedRoute,
    private http: HttpService,
    private auth: AuthService
  ) { }

  ngOnInit() {
  }

  onLogin(form: NgForm) {
    this.http.login(form.value.username, form.value.password).subscribe(
      (detail: LoginDetail) => {
        this.auth.login(form.value.username, detail.client, detail.token);

        if (this.snapshot.queryParams['return']) {
          this.router.navigateByUrl(this.snapshot.queryParams['return']);
        } else {

          let url = '/account';

          // TODO: replace with actual per-user/client default page, maybe from DB?
          if (this.auth.user == 'glyn.baker' || this.auth.user == 'richard.flowitt') {
            url = '/weedfree/forms/mmt';
          } else if (detail.client == 1 || detail.client == 2) {
            url = '/handspray/map';
          } else if (detail.client > 2 && detail.client < 6) {
            url = '/support-service/map';
          }

          this.router.navigateByUrl(url);
        }
      },
      (error) => {
        this.loginError = error.error;
      });
  }
}
